<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="inviteMemberDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Invite Member</div
  >

  <form
    class="flex w-80 flex-col"
    [formGroup]="inviteMemberForm"
    (ngSubmit)="invite()"
  >
    <input
      autocomplete="off"
      #email
      spellcheck="false"
      data-cy="inviteMemberDialogEmailInput"
      class="form-input border-s3 focus:border-m600 mt-9 rounded"
      [ngClass]="{
        'border-r600':
          inviteMemberForm.controls['email'].invalid &&
          inviteMemberForm.controls['email'].touched
      }"
      formControlName="email"
      placeholder="Email"
    />
    <m-validation [control]="inviteMemberForm.controls['email']"></m-validation>

    <div class="mt-6">
      <button
        data-cy="inviteMemberDialogInviteButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Invite</button
      >

      <button
        data-cy="inviteMemberDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
